import BesnikTahiri from "../assets/images/BesnikTahiri.jpeg";
import GenciNimanbegu from "../assets/images/GenciNimanbegu.jpg";
import EdiRama from "../assets/images/EdiRama.webp";
import TiborDraskovics from "../assets/images/TiborDraskovic.jpeg";
import NicholasAbbott from "../assets/images/NicholassAbbott.jpg";
import AnuelaRistani from "../assets/images/AnuelaRistani.jpeg";
import FriedhelmFrischenschlager from "../assets/images/FriedhelmFrischenschlager.jpg";
import FatmirGjeka from "../assets/images/FatmirGjeka.jpeg";
import JosipBrkic from "../assets/images/JosipBrkic.jpeg";
import HarryHardman from "../assets/images/Harry.jpeg";
import AdeaPirdeni from "../assets/images/AdeaPirdeni.jpg";
import MassimilianoPaolucci from "../assets/images/MassimilianoPaolucci.png";
import SimonMeally from "../assets/images/SimonMeally.png";
import ArbjanMazniku from "../assets/images/ArbjanMazniku.png";
import ArbenFetai from "../assets/images/ArbenFetai.png";
import MarkBaskin from "../assets/images/MarkBaskin.jpeg";
import DimitrieVasile from "../assets/images/Dimitrie-Vasile.jpeg";
import NorbertPiljs from "../assets/images/NorbertPiljs.jpeg";
import SilvioGonzato from "../assets/images/SilvioGonzato.png";
import ModestaImeri from "../assets/images/ModestaImeri.png";
import JetaLoshaj from "../assets/images/JetaLoshaj.jpeg";
import ValmirGashi from "../assets/images/ValmirGashi.png";
import RankoKrivokapic from "../assets/images/RankoKrivokapić.png";
import HajdiXhixha from "../assets/images/HajdiXhixha.jpeg";

const speakers = [
  {
    id: "edi-rama",
    name: "Edi Rama",
    title: "Prime Minister of Albania",
    image: EdiRama,
  },
  {
    id: "besnik-tahiri",
    name: "Besnik Tahiri",
    title:
      "Founder and President of IGC | Former Deputy Prime Minister and Foreign Affairs Minister of Kosovo | Member of Parliament | Senior Expert in Public Sector",
    image: BesnikTahiri,
    pdfLink: "/publications/concept-IGC.pdf",
    pdfTitle: "Concept Note - IGC",
  },
  {
    id: "mayor-harry",
    name: "Mayor Harry Hardman",
    title:
      "The Bush School of Government and Public Service Advisory Board Member",
    image: HarryHardman,
  },
  {
    id: "adea-pirdeni",
    name: "Adea Pirdeni",
    title: "Minister of State for Public Administration and Anti-Corruption",
    image: AdeaPirdeni,
  },
  {
    id: "hajdi-xhixha",
    name: "Hajdi Xhixha",
    title: "Professor of Political Science and Security Studies",
    image: HajdiXhixha,
  },
  {
    id: "arbjan-mazniku",
    name: "Arbjan Mazniku",
    title: "Minister of State for Local Governance",
    image: ArbjanMazniku,
  },
  {
    id: "anuela-ristani",
    name: "Anuela Ristani",
    title: "Acting Mayor of Tirana, Albania",
    image: AnuelaRistani,
  },
  {
    id: "ranko-krivokapic",
    name: "Ranko Krivokapic",
    title: "Former Minister of Foreign Affairs of Montenegro",
    image: RankoKrivokapic,
  },
  {
    id: "nicholas-abbott",
    name: "H.E. Nicholas Abbott",
    title: "British Ambassador to Albania",
    image: NicholasAbbott,
  },
  {
    id: "silvio-gonzato",
    name: "Silvio Gonzato",
    title:
      "EU Ambassador to Albania, Deputy Head of the Delegation of the European Union to the United Nations in New York",
    image: SilvioGonzato,
  },
  {
    id: "modesta-imeri",
    name: "Modesta Imeri",
    title: "CEO of Blue Dot Consulting, University of Pennsylvania Alumna",
    image: ModestaImeri,
  },
  {
    id: "massimiliano-paolucci",
    name: "Massimiliano Paolucci",
    title: "World Bank Group Country Manager for Albania",
    image: MassimilianoPaolucci,
  },
  {
    id: "arben-fetai",
    name: "Arben Fetai",
    title: "Deputy Prime Minister of North Macedonia for Good Governance",
    image: ArbenFetai,
  },
  {
    id: "jeta-loshaj",
    name: "Jeta Loshaj",
    title:
      "Senior Researcher at KCSS, MSc in Russian & East European Studies from Indiana University",
    image: JetaLoshaj,
  },
  {
    id: "friedhelm-frischenschlager",
    name: "Friedhelm Frischenschlager",
    title:
      "Former Austrian Minister of Defense | Co-Founder of the Liberal Forum | European Political Advisor",
    image: FriedhelmFrischenschlager,
  },
  {
    id: "genc-nimani",
    name: "Genci Nimanbegu",
    title:
      "Mayor of Ulcinj, F/Member of Parliament of Montenegro and President of the Party - New Democratic Force",
    image: GenciNimanbegu,
  },
  {
    id: "tibor-draskovics",
    name: "Mr. Tibor Draskovics",
    title:
      "Public Policy and Governance Expert, Former Minister of Finance, Minister of Justice and Law Enforcement of Hungary",
    image: TiborDraskovics,
  },
  {
    id: "josip-brkic",
    name: "Josip Brkić",
    title: "Deputy Minister of Foreign Affairs of Bosnia and Herzegovina",
    image: JosipBrkic,
  },
  {
    id: "fatmir-gjeka",
    name: "Fatmir Gjeka",
    title:
      "Minister for Human and Minority Rights in the Government of Montenegro, F/MP of Parliament of Montenegro",
    image: FatmirGjeka,
  },
  {
    id: "valmir-gashi",
    name: "Valmir Gashi",
    title: "Executive Director of the Kosovo Local Government Institute",
    image: ValmirGashi,
  },
  {
    id: "mark-baskin",
    name: "Mark Baskin",
    title: "Senior Adviser on the Balkans, Center for Humanitarian Dialogue",
    image: MarkBaskin,
  },
  {
    id: "dimitrie-vasile",
    name: "Dimitrie Vasile",
    title: "Senior Governance Specialist, World Bank",
    image: DimitrieVasile,
  },
  {
    id: "simon-meally",
    name: "Simon O'Meally",
    title: "Senior Public Sector Economist, The World Bank",
    image: SimonMeally,
  },
  {
    id: "norbert-piljs",
    name: "Norbert Piljs",
    title: "Director Bashki të Fortë Project, Helvetas Albania",
    image: NorbertPiljs,
  },
];

export default speakers;
